import React from 'react';
import { Button, Typography } from '@doveit/lego';
import { useRouter } from 'next/router';
import { BasicSectionProps } from '../types';
import PageSection from '../../components/page-section/PageSection';
import Markdown from '../../components/markdown/Markdown';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';
import PropertySearchResultCardList from '../../components/property-search-result-card-list/PropertySearchResultCardList';
import { buildListingURLObject, goToPage } from '../../utils/links';
import { PropertySearchResult } from '../../../services/dtos';
import { TextAlign } from '../../types';

export interface PropertiesForSaleSectionProps extends BasicSectionProps {
  properties: PropertySearchResult[],
  action?: {
    label: string,
    href: string,
  },
}

/**
 * Poiché il componente PropertySearchResultCardList usa dei searchResult,
 * siamo al momento costretti ad esporre la tipologia PropertySearchResult dal componente
 * Nel refactoring dei vari sottocomponenti, valutiamo se è il caso di esporre un tipo semplificato e più generico
 */
export const PropertiesForSaleSection: React.FC<PropertiesForSaleSectionProps> = ({
  title,
  content,
  properties,
  action,
}) => {
  const { push } = useRouter();
  const hasHeader = !!(title || content);

  return (
    <PageSection>
      {hasHeader && (
        <PageSection.Wrapper>
          {title && (
            <PageSection.Title>
              <Markdown>
                {title.trim()}
              </Markdown>
            </PageSection.Title>
          )}
          {content && (
            <PageSection.Block>
              <Typography.BODY>
                <ArticleMarkdown>
                  {content.trim()}
                </ArticleMarkdown>
              </Typography.BODY>
            </PageSection.Block>
          )}
        </PageSection.Wrapper>
      )}
      <PageSection.Wrapper withoutPad>
        <PageSection.Block noSpacing={!hasHeader}>
          <PropertySearchResultCardList
            items={properties.map((searchResult) => ({
              searchResult,
              urlObject: buildListingURLObject(searchResult),
              onClick: () => goToPage(buildListingURLObject(searchResult)),
            }))}
          />
        </PageSection.Block>
      </PageSection.Wrapper>
      {action && (
        <PageSection.Wrapper>
          <PageSection.Actions textAlign={TextAlign.CENTER}>
            <Button
              label={action.label}
              href={action.href}
              onClick={() => push(action.href)}
            />
          </PageSection.Actions>
        </PageSection.Wrapper>
      )}
    </PageSection>
  );
};

export default PropertiesForSaleSection;
